import React from "react"
import Svg from "../../utils/Svg"
import Path from "../../utils/Path"

const TumblrSvg = ({ color = "primary", ...rest }) => {
  return (
    <Svg
      fill="none"
      width="33"
      height="33"
      viewBox="-1.5 -7 12 28"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <Path
        fill={color}
        d="m6.38795 16c-2.41055 0-4.19837-1.2354-4.19837-4.1984v-4.74071h-2.18958v-2.57125c2.41055-.62272 3.41494-2.69177 3.52542-4.48964h2.50094v4.07784h2.91275v2.98305h-2.91275v4.12811c0 1.2354.62273 1.6672 1.61708 1.6672h1.4162v3.1438z"
      />
    </Svg>
  )
}

export default TumblrSvg
